<div class="break-inside-avoid">
  <h2 rmaBackToMap class="mat-headline-4 mb-8 text-center" [selectedItemId]="$safeNavigationMigration(selectedItemId?.toString())">
    {{ 'marketReports.reviews-verified-by' | transloco }}
    <img alt="RateMyAgent" class="inline" [src]="'/logos/logo-dark.svg' | staticImageUrl" width="145" />
  </h2>

  @if (markers$ | async; as markers) {
    @if ((isPrintMode && printedUrl) || markers.length) {
      <rma-market-report-reviews-map
        class="my-8 w-full"
        [class.h-80]="!isPrintMode"
        [isPrintMode]="isPrintMode"
        [printedUrl]="printedUrl"
        [markers]="markers"
        (markerSelected)="onMarkerSelected($event)"
      />
    }
  }
</div>

<hr class="my-6 text-steel-20 print:hidden" />

<section class="reviews-section">
  @for (review of reviews; track review) {
    <rma-market-report-review-tile
      class="break-inside-avoid"
      [id]="review.reviewId"
      [review]="review"
      [isReportOwner]="isReportOwner"
      [selected]="review.reviewId.toString() === selectedItemId"
      [isPrintMode]="isPrintMode"
    />
  }
</section>
